import React from "react";

import { useSelector } from "../../utils/hooks";

import "./SubscriptionInfo.scss";

const SubscriptionReadMore = () => {
	const subscription = useSelector(
		(state) => state.popup.products.mainProduct.subscription,
	);

	const showSubscriptionDataOnly = useSelector(
		(state) => state.popup.showSubscriptionDataOnly,
	);

	return (
		<div className="addtocart-subscription-details__more-info-bottom">
			<span
				dangerouslySetInnerHTML={{
					__html: showSubscriptionDataOnly
						? subscription.readMoreBottom
						: subscription.moreInfoBottom,
				}}
			/>
		</div>
	);
};

export default SubscriptionReadMore;
